/**
 * Get the color palette used for shards and saturation
 */
export function getColorPalette(): { r: number; g: number; b: number; name: string }[] {
  return [
    { r: 229, g: 10, b: 174, name: 'punch' }, // punch: #E50AAE
    { r: 255, g: 121, b: 25, name: 'zest' }, // zest: #FF7919
    { r: 195, g: 229, b: 0, name: 'highlighter' }, // highlighter: #C3E500
    { r: 54, g: 217, b: 85, name: 'slime' }, // slime: #36D955
    { r: 118, g: 230, b: 235, name: 'powder' }, // powder: #76E6EB
  ]
}

// Add the olive color palette
export function getOliveColorPalette(): { r: number; g: number; b: number; name: string }[] {
  return [
    // { r: 38, g: 50, b: 12, name: 'olive-1' }, // olive-1: #26320C
    // Added dupes so olive 2 is randomly selected way more.
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 29, g: 38, b: 9, name: 'olive-2' }, // olive-2: #1D2609
    { r: 25, g: 33, b: 8, name: 'olive-3' }, // olive-3: #192108
    { r: 19, g: 26, b: 6, name: 'olive-4' }, // olive-4: #131A06
    // { r: 13, g: 17, b: 4, name: 'olive-5' }, // olive-5: #0D1104
  ]
}
